import { WeatherService } from '../../weather/weather/weather.service';
import { LatLon } from '../../util/geodesy/latlon';
import { PromiseState, StatefulPromise } from '../../util/stateful-promise';
import { WeatherLegendComponent } from '../../shared/weather-legend/weather-legend.component';
import { MatDialog } from '@angular/material';
var TafSectionComponent = /** @class */ (function () {
    function TafSectionComponent(_wx, _dialog) {
        this._wx = _wx;
        this._dialog = _dialog;
        this._clsWxSection = true;
    }
    Object.defineProperty(TafSectionComponent.prototype, "latlon", {
        /**
         * Returns the latlon of the primary station identifier
         */
        get: function () {
            return this._latlon;
        },
        /**
         * Sets the lat/lon to be used as the center point when querying TAFs. This is required (all TAF data, including
         * for the primary identifier, is loaded by lat/lon).
         */
        set: function (value) {
            if (this._latlon !== value) {
                this._latlon = value;
                this._load();
            }
        },
        enumerable: true,
        configurable: true
    });
    TafSectionComponent.prototype._load = function () {
        this.tafPromise = new StatefulPromise(this._wx.getTafsByLatLon(this._latlon));
    };
    Object.defineProperty(TafSectionComponent.prototype, "_tafs", {
        get: function () {
            var _this = this;
            if (!this.tafPromise || this.tafPromise.state !== PromiseState.Fulfilled) {
                return null;
            }
            this.tafPromise.value.forEach(function (taf) {
                _this.fixADDSTempoIssue(taf);
            });
            return this.tafPromise.value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TafSectionComponent.prototype, "primaryTaf", {
        /**
         * Returns the primary TAF
         * @returns {Taf}
         */
        get: function () {
            var _this = this;
            // this selects the TAF for the current airport, if there is one
            // it intentionally checks again after prepending a K to the identifier to account for fake ICAO ADDS airports (like M91)
            var tempTaf = null;
            if (this._tafs) {
                tempTaf = this._tafs.find(function (taf) { return taf.stationId === _this.identifier; });
                if (!tempTaf) {
                    tempTaf = this._tafs.find(function (taf) { return taf.stationId === 'K' + _this.identifier; });
                }
            }
            return tempTaf;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TafSectionComponent.prototype, "nearbyTafs", {
        /**
         * Returns nearby TAFs (excluding the primary TAF)
         * @returns {Array<Taf>}
         */
        get: function () {
            var _this = this;
            // this returns the nearby TAFs by filtering out a local TAF, if there is one
            // it intentionally checks twice prepending a K to the identifier the second time to account for fake ICAO ADDS airports (like M91)
            return (this._tafs || []).filter(function (taf) { return taf.stationId !== _this.identifier && taf.stationId !== 'K' + _this.identifier; });
        },
        enumerable: true,
        configurable: true
    });
    TafSectionComponent.prototype.openWeatherLegend = function () {
        var dialogRef = this._dialog.open(WeatherLegendComponent, {
        // height: '500px'
        });
    };
    TafSectionComponent.prototype.fixADDSTempoIssue = function (taf) {
        var validflightCategories = new Set(['VFR', 'MVFR', 'IFR', 'LIFR']);
        var prevForecast = taf.forecasts[0];
        taf.forecasts.forEach(function (forecast) {
            if (forecast.changeIndicator === 'TEMPO') {
                var curCeiling = 9999;
                var curVisibility = 10;
                if (forecast.ceiling && forecast.ceiling !== 'None') {
                    curCeiling = Number(forecast.ceiling.match(/\d+/)[0]);
                }
                if (forecast.visibility) {
                    curVisibility = Number(forecast.visibility.match(/\d+/)[0]);
                }
                if (!validflightCategories.has(forecast.flightCategory)) {
                    forecast.flightCategory = prevForecast.flightCategory;
                    if (curCeiling <= 500 || curVisibility <= 1) {
                        forecast.flightCategory = 'LIFR';
                    }
                    else if (curCeiling <= 1000 || curVisibility <= 3) {
                        forecast.flightCategory = 'IFR';
                    }
                    else if (curCeiling <= 3000 || curVisibility <= 5) {
                        forecast.flightCategory = 'MVFR';
                    }
                    // console.log('changed tempo: ', taf.stationId);
                }
                if (!forecast.visibility) {
                    forecast.visibility = prevForecast.visibility;
                }
                if (!forecast.wxStringTrans) {
                    forecast.wxStringTrans = prevForecast.wxStringTrans;
                }
                if (!forecast.wind || forecast.wind.calm) {
                    forecast.wind = prevForecast.wind;
                }
                if (prevForecast.windShearHgtFtAgl && !forecast.windShearHgtFtAgl) {
                    forecast.windShearHgtFtAgl = prevForecast.windShearHgtFtAgl;
                }
                if (prevForecast.windShearSpeedKt && !forecast.windShearSpeedKt) {
                    forecast.windShearSpeedKt = prevForecast.windShearSpeedKt;
                }
                if (prevForecast.windShearDirDegrees && !forecast.windShearDirDegrees) {
                    forecast.windShearDirDegrees = prevForecast.windShearDirDegrees;
                }
                if (forecast.turbulence.length === 0) {
                    forecast.turbulence = prevForecast.turbulence;
                }
                if (forecast.icing.length === 0) {
                    forecast.icing = prevForecast.icing;
                }
                if (forecast.skyConditions.length === 0) {
                    forecast.skyConditions = prevForecast.skyConditions;
                }
            }
            else if (forecast.changeIndicator === 'FM' || forecast.changeIndicator === 'BECMG') {
                prevForecast = forecast;
            }
        });
    };
    return TafSectionComponent;
}());
export { TafSectionComponent };
